import { ChangeDetectionStrategy, Component, Input, Optional } from '@angular/core';
import { Router } from '@angular/router';
import { Game, Team } from '@mtgame/core';
import { DialogConfig } from '@mtgame/ui';

@Component({
  selector: 'mtg-tournament-playoff-game-dialog',
  templateUrl: './tournament-playoff-game-dialog.component.html',
  styleUrls: ['./tournament-playoff-game-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TournamentPlayoffGameDialogComponent {
  @Input()
  games: Game[];
  @Input()
  team: Team;
  @Input()
  competitorTeam: Team;
  @Input()
  teamScore: number;
  @Input()
  competitorTeamScore: number;
  @Input()
  teamWinnerId: number;
  @Input()
  gameRoute: string;
  @Input()
  openInNewWindow: boolean;

  constructor(
    private router: Router,
    @Optional() private dialogConfig: DialogConfig,
  ) {
    if (this.dialogConfig && this.dialogConfig.data) {
      this.games = this.dialogConfig.data.games;
      this.team = this.dialogConfig.data.team;
      this.competitorTeam = this.dialogConfig.data.competitorTeam;
      this.teamScore = this.dialogConfig.data.teamScore;
      this.competitorTeamScore = this.dialogConfig.data.competitorTeamScore;
      this.teamWinnerId = this.dialogConfig.data.teamWinnerId;
      this.gameRoute = this.dialogConfig.data.gameRoute;
      this.openInNewWindow = this.dialogConfig.data.openInNewWindow;
    }
  }

  getGameRoute(game: Game): string {
    if (!this.gameRoute) {
      return null;
    }
    return  this.gameRoute.replace(':gameId', game.id.toString());
  }
}
